/**
 * Micro-celebracoes — confetti helpers para momentos-chave
 * Usa canvas-confetti (ja instalado).
 *
 * Usage:
 *   import { celebrate } from '@/lib/celebrate';
 *   celebrate.mission();     // Missao completa
 *   celebrate.rankUp();      // Subiu de rank
 *   celebrate.firstStory();  // Primeira historia
 *   celebrate.streak();      // Streak de 7 dias
 *   celebrate.gold();        // Confetti dourado generico
 */

import confetti from 'canvas-confetti';

// MadBoat gold palette for confetti
const GOLD_COLORS = ['#D4AF37', '#F5D060', '#FFD700', '#B8860B'];
const RANK_COLORS = ['#3B82F6', '#06B6D4', '#34D399', '#F59E0B', '#EF4444', '#FFD700'];

function fire(options: confetti.Options) {
  confetti({
    disableForReducedMotion: true,
    ...options,
  });
}

export const celebrate = {
  /** Missao completa — confetti dourado sutil */
  mission() {
    fire({
      particleCount: 60,
      spread: 55,
      origin: { y: 0.7 },
      colors: GOLD_COLORS,
      scalar: 0.8,
    });
  },

  /** Subiu de rank — confetti explosivo */
  rankUp() {
    // Burst esquerda
    fire({
      particleCount: 80,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.65 },
      colors: RANK_COLORS,
    });
    // Burst direita
    fire({
      particleCount: 80,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.65 },
      colors: RANK_COLORS,
    });
  },

  /** Primeira historia — confetti sutil */
  firstStory() {
    fire({
      particleCount: 40,
      spread: 70,
      origin: { y: 0.6 },
      colors: ['#D4AF37', '#F5D060', '#ffffff'],
      scalar: 0.7,
      gravity: 0.8,
    });
  },

  /** Streak 7 dias — particulas de fogo */
  streak() {
    fire({
      particleCount: 50,
      spread: 40,
      origin: { y: 0.7 },
      colors: ['#EF4444', '#F59E0B', '#FFD700', '#FF6B35'],
      shapes: ['circle'],
      scalar: 0.6,
      drift: 0,
    });
  },

  /** Confetti dourado generico */
  gold() {
    fire({
      particleCount: 50,
      spread: 60,
      origin: { y: 0.65 },
      colors: GOLD_COLORS,
    });
  },
};
